module.exports = __webpack_public_path__ + "440cbd56da1d9d8f5d25353c76a9002c.svg";